import { useEffect, useState } from "react";

import { GetChartMetadata } from "@/Utils/Promises";
import { useWSMgrContext } from "@/providers/WsMgrProvider";

export const useBaseCharts = () => {
  const wsMgrContext = useWSMgrContext();
  const wsMgr = wsMgrContext.wsMgr.state;
  const baseChartIDs = wsMgr
    .GetOrgInfo()
    .GetMasterChartList()
    .map(c => c["ID"]);

  const [baseCharts, setBaseCharts] = useState([]);

  // Load Full Chart Objects
  useEffect(() => {
    let aborted = false;

    (async () => {
      const charts = [];
      for (const chartID of baseChartIDs) {
        const { result } = await GetChartMetadata(chartID);
        if (aborted) {
          return;
        }

        charts.push(result);
      }

      if (!aborted) {
        setBaseCharts(charts);
      }
    })();

    return () => {
      aborted = true;
    };
  }, [JSON.stringify(baseChartIDs)]);

  const updateBaseChart = updatedChart => {
    setBaseCharts(prevCharts => {
      return prevCharts.map(c => {
        if (c["ID"] !== updatedChart["ID"]) {
          return c;
        }

        return updatedChart;
      });
    });
  };

  return { baseCharts, updateBaseChart };
};
